import { createFileRoute, Outlet } from '@tanstack/react-router'
import LocationSwitcher from "@/components/location-switcher";
import { ThaloWebContextProvider } from "@/contexts/ThaloWebContext";
import { AllAssetsContextProvider } from "@/contexts/AllAssetsContext";
import { SelectedAssetsContextProvider } from "@/contexts/SelectedAssetsContext";
import { ChartOptionsContextProvider } from "@/chartOptions/ChartOptionsContext";

export const Route = createFileRoute(
  '/_authenticated/_staff/_with_location_switcher',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <ThaloWebContextProvider>
        <ChartOptionsContextProvider>
          <AllAssetsContextProvider>
            <SelectedAssetsContextProvider>
              <LocationSwitcher/>
              <Outlet/>
            </SelectedAssetsContextProvider>
          </AllAssetsContextProvider>
        </ChartOptionsContextProvider>
      </ThaloWebContextProvider>
    </>
  )
}
